import request from '@/utils/request'

export function getEnterpriseNumBlock(id) {
  return request({
    url: '/job/enterprise/getEnterpriseNumBlock',
    method: 'get',
    params:{id:id}
  })
}


export function updateEnterprise(data) {
  return request({
    url: '/user/enterprise/updateEnterprise',
    method: 'post',
    data
  })
}

export function refreshEnterpriseCache(data) {
  return request({
    url: '/user/enterprise/refreshEnterpriseCache',
    method: 'post',
    data
  })
}
export  function getEnterpriseInfo(data) {
  return request({
    url: '/user/enterprise/getEnterpriseInfo',
    method: 'post',
    data
  })
}

export  function getEnterpriseAll(data) {
  return request({
    url: '/user/enterprise/getEnterpriseAll',
    method: 'post',
    data,
    headers: {
      "hideLoading": true
    }
  })
}
export  function createSubAccount(data) {
  return request({
    url: '/user/enterprise/createSubAccount',
    method: 'post',
    data
  })
}
export  function listSubAccount(data) {
  return request({
    url: '/user/enterprise/listSubAccount',
    method: 'post',
    data
  })
}
export  function deleteSubAccount(data) {
  return request({
    url: '/user/enterprise/deleteSubAccount',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/enterprise.js